<template>
  <div class="line-items-footer-taxes-summary-js">
    <div v-for="summaryTax in summaryTaxes"
         :key="`tax-${summaryTax.id}`"
         class="line-items-footer-item px-i">
      <div class="line-items-footer-item-start tax-summary-name-js">
        {{ summaryTax.name }} ({{ summaryTax.rate | formatPercentage }})
      </div>

      <div class="line-items-footer-item-end tax-summary-amount-js">
        {{ summaryTax.amount | formatCurrency(selectedCurrency.iso_code) }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("lineItems", [
      "selectedCurrency",
      "summaryTaxes"
    ])
  }
};
</script>
